module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f1Wto"))).then(() => module.bundle.root('d0iPb'));